module.exports = __webpack_public_path__ + "static/future-footer-image-840441f0fd85abb3947d0d6c99598d64.jpg";